import programacionAudiencias from "./programacionDeAudiencias/ProgramacionDeAudienciasTemporal.js";

const sistema = {
    programacionAudiencias : programacionAudiencias
};

export default sistema;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/AudienciasTemporal/sistema/SistemaAudienciaTemporal.js
// module id = null
// module chunks = 